<div class="row thankyou-headline columns">
	<h1 *ngIf="!eventThankYou">{{ (step != 'end'? textkeyHeadline : 'thankyou.headline.end') | translate }}</h1>
</div>